import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { getUsers } from 'data/api/get-users'
import { transformPaginationDto } from '@marketplace-web/shared/pagination-data'
import { transformUserDtos } from '@marketplace-web/shared/user-data'
import { UsersResp } from 'types/api/response/users-resp'

export const transformUsersResponse = (response: UsersResp) => ({
  users: transformUserDtos(response.users),
  pagination: transformPaginationDto(response.pagination),
})

const DEFAULT_PER_PAGE = 36

const useFetchUsers = (searchText: string, page: number) => {
  const {
    fetch: fetchUsers,
    transformedData: data,
    isLoading,
    error,
  } = useFetch(getUsers, transformUsersResponse)

  useEffect(() => {
    fetchUsers({
      perPage: DEFAULT_PER_PAGE,
      searchText,
      page,
    })
  }, [fetchUsers, searchText, page])

  return { data, isLoading, error }
}

export default useFetchUsers
